import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { DateTime } from 'luxon';
import { TimeService } from '../time.service';
import { EventService } from '../event.service';
import { HttpService } from '../http.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../snackbar.service';
import { ViewAttendanceComponent } from './view-attendance/view-attendance.component';
import { ViewSalaryComponent } from './view-salary/view-salary.component';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-attendance-salary',
  templateUrl: './attendance-salary.component.html',
  styleUrls: ['./attendance-salary.component.scss']
})
export class AttendanceSalaryComponent implements OnInit {



  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  displayColumns = ['slno','driver','type','present','absent','actions'];
  attendnanceList:MatTableDataSource<any>;

  symbol;
  selectedYear;
  months = [
    { name:'January',value:1 },
    { name:'February',value:2 },
    { name:'March',value:3 },
    { name:'April',value:4 },
    { name:'May',value:5 },
    { name:'June',value:6 },
    { name:'July',value:7 },
    { name:'August',value:8 },
    { name:'September',value:9 },
    { name:'October',value:10 },
    { name:'November',value:11 },
    { name:'December',value:12 },
  ]

  years = [2019,2020,2021];

  subscription: Subscription;
  selectedRow;
  searchTextChanged = new Subject<object>();
  showLoader = false;
  date_filter:any = {
    from_date: Date,
    to_date: Date,
  };
  filters: any = {
    name: '',
    month:''
  };
  selectedMonth;
  totalCount = 0;
  attendnance_list =[];

  attendnanceFilters:any ={
    // limit:0,
    // skip:0
  };

  shipperId:Subscription;

  constructor(private http:HttpService,private changeDetection: ChangeDetectorRef,private translate:TranslateService,private dialog: MatDialog,private timeService:TimeService,private snackbar:SnackbarService,private events:EventService) { }

  ngOnInit() {
    this.setTime();
    // this.getAttendnanceList();
    const rupee = JSON.parse(localStorage.getItem('shippers'));
    this.symbol = rupee[0].country.currency.symbol;
    this.shipperId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getAttendnanceList(this.attendnanceFilters);
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  refreshDashboard(){
    this.getAttendnanceList(this.attendnanceFilters);
  }

  setTime(){
    let current_month = new Date().getMonth();
    let current_year = new Date().getFullYear();
    if(current_month == 0){
      current_month = 12;
      current_year = current_year - 1;
    }
    this.filters.year = current_year;
    let month = this.months.filter((month)=>{
      return month.value == current_month
    })[0];
    this.filters.month = month.name;
    this.attendnanceFilters.month = current_month;
    this.attendnanceFilters.year = current_year;
    this.getAttendnanceList(this.attendnanceFilters);
  }

  getAttendnanceList(filter:any = {}){
    // filter.limit = this.paginator.pageSize || 25;
    // filter.skip =  this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);

    this.showLoader = true;
    this.http.get('driver/attendance/get_all',filter,3).subscribe((response:any)=>{
      this.showLoader = false;

      if(response.statusCode == 200){
        const data = response.data.drivers;
        this.totalCount = response.data.count || 0;
        this.attendnance_list = [];
        const driverType = {
         contracted: 'Contracted',
          aggregated: 'Aggregated',
          own: 'Own'
        };
        data.forEach((element,index)=>{
          const temp:any = {};
          temp.index = index+1,
          temp.id = element.driver._id;
          temp.driver_name = element.driver ? element.driver.name : '--';
          temp.driver_mobile = element.driver ? element.driver.mobile : '--';
          temp.driver_type = element.driver ? (element.driver.driver_type == 'contracted') ? driverType.contracted : ((element.driver.driver_type == 'aggregated') ? driverType.aggregated : ( (element.driver.driver_type == 'own') ? driverType.own : 'N/A' ) ):'N/A';
          temp.present = element.present_days;
          temp.absent = element.absent_days;
          temp.paid_leaves = element.paid_leaves;
          temp.lop = element.lop;
          temp.holidays = element.holidays;
          this.attendnance_list.push(temp);
        });
        if (!this.attendnanceList) {
          this.attendnanceList = new MatTableDataSource(this.attendnance_list);
          this.attendnanceList.sort = this.sort;
          this.attendnanceList.paginator = this.paginator;
          this.paginator._intl.itemsPerPageLabel= this.translate.instant('DRIVERS.pagination_label');
        } else {
          this.attendnanceList = new MatTableDataSource(this.attendnance_list);
          this.paginator._intl.itemsPerPageLabel= this.translate.instant('DRIVERS.pagination_label');
        }
      }
    },
    (err)=>{
      this.showLoader = false;
      this.snackbar.openSnackBar(err.error.message,'','err');
    });
  }

  pageNavigate(event){
    this.attendnanceFilters.limit = event.pageSize;
    this.attendnanceFilters.skip = event.pageIndex * event.pageSize;
    this.getAttendnanceList(this.attendnanceFilters);
  }

  selectMonth(month,event){
    this.selectedMonth = month;
    this.attendnanceFilters.month = month.value;
    this.getAttendnanceList(this.attendnanceFilters);
  }

  selectYear(year){
    this.attendnanceFilters.year = year;
    this.getAttendnanceList(this.attendnanceFilters);
  }

  openView(element){
      const dialogRef = this.dialog.open(ViewAttendanceComponent, {
        data:element
      });
  }

  openSalaryDetails(element){
    const dialogRef = this.dialog.open(ViewSalaryComponent, {
      data:element
    });
  }

  searchFilter(value, type) {
    this.changeDetection.detectChanges();
    if (value.length) {
      switch (type) {
        case 'driver':
          this.attendnanceFilters.driver = value;
          break;
      }
      this.reSubscribe();
      this.searchTextChanged.next(this.attendnanceFilters);
    }else{
      this.clearFilter(type);
    }
  }

  clearFilter(type) {
    switch (type) {
      case 'driver':
        delete this.attendnanceFilters.driver;
        break;
    }
    this.getAttendnanceList(this.attendnanceFilters);
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getAttendnanceList(x); });
    this.changeDetection.detectChanges();
  }
  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  sortTripSheets(){

  }

  ngOnDestroy() {
    this.shipperId.unsubscribe();
   }

}
